export default __webpack_public_path__ + "static/media/plate.878c23ce.png";